var _circle, _path, _path2, _path3, _path4, _path5, _path6, _polyline, _polyline2, _line, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 261.3 80.19 80.19",
    width: 80.19,
    height: 80.19,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.1,
    cy: 301.46,
    r: 38.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.61,339.14l.29-23.09s-5.79.78-9.13,0l-.27,23.18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.64,330.68c.59-.37,1.5-.78,2.57-.63,1.23.17,1.75.95,2.88,1.3.79.25,1.96.31,3.54-.67-.03,3.11-.06,6.21-.09,9.32h-8.99l.09-9.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.76,310.64s.2.07.17,1.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.64,293.07v10.45s-5.11,1.75-11.35,0v-15.82c4.22-.9,8.18-.52,10.12-.22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39,318.53s-.72-.44-1.97,0c0,0-.36,1.53-1.03,2.54,0,0-1.07,7.36,1.88,7.54l.22.04s2.77.57,1.83-7.54c0,0-.72-1.1-.94-2.59Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.46,310.08c-1.45.01-3.78.14-3.72.83v5.11s6.01,1.04,9.15-.03v-5.08s.35-.82-4.31-.82"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "38.55 311.14 38.55 304.52 37.52 304.52 37.52 311.2"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "37.52 316.36 37.52 318.53 38.55 318.53 38.55 316.36"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 37.22,
    y1: 311.19,
    x2: 38.83,
    y2: 311.21
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.99,316.39s1.29.1,2.14.08"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.16,287.86c-1.99.2-5.99.46-9.47-.22,0,0,4.39-1.45,9.66-.21"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.29,272.09s-1.29,1.98-3.36,4.15c0,0-2.54,2.81-3.32,3.96-.59.93-1.23,1.89-1.95,2.87-1.05,1.45-2.11,2.76-3.13,3.92-.86.94-1.73,1.91-2.6,2.89-.86.97-1.69,1.94-2.51,2.89-.25.18-1.23.84-2.54.67-.74-.1-1.27-.42-1.55-.62-.23-.39-.54-.96-.76-1.7,0,0-.24-.8-.3-1.74-.08-1.34.36-3.71,1.52-6.5.71-1.88,1.43-3.76,2.14-5.65"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.38,286.92c.6-1.28,1.22-2.86,1.7-4.65,1.03-2.45,2.06-4.89,3.09-7.34"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.89,266.01c-.21.58-.68,1.75-.84,2.14-.34.8-3.55,9.32-4.43,11.3,0,0-2.74,8.46-1.99,10.87.23.74.59,1.33.92,1.76.34.13,1.33.46,2.53.1.06-.02.13-.04.13-.04.04-.01.07-.02.09-.03"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.04,269.83s-1.7,3.82-4.24,4.47c0,0-1.7,2.76-3.31,3.13,0,0-1.7.78-2.58,1.24,0,0-2.35.51-4.51-.41-.75-.34-1.51-.7-2.29-1.1-2.45-1.25-4.61-2.6-6.5-3.94-.31-.23-.63-.5-.96-.83-1.03-1.03-1.54-2.06-1.8-2.58-.41-.85-.87-1.77-.96-3.08-.1-1.39.26-2.53.57-3.26"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.84,263.3c-.44,2.55.44,3.71.7,4.02.47.55,1.3,1.06,2.96,2.08.18.11.43.25.73.42.41.22.9.48,1.25.59,0,0,5.62,5.07,10.96,3.64"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.79,310.7s.69.58,4.71.5c0,0,3.97.1,4.12-.58"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.79,316.05s.69.58,4.71.5c0,0,3.97.1,4.12-.58"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.21,311.1v-18.79c-.17-.07-.41-.14-.71-.15-.41-.02-.73.08-.93.15v18.81l-2.29.03,3.17,5.75,3.04-5.82-2.29.03Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4);
export default __webpack_public_path__ + "static/media/img4.75c08f639523b6168e5ce3dea0544dbb.svg";
export { ForwardRef as ReactComponent };